<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>尖峰平谷规则</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>
			<!-- <el-form-item label="搜索：">
				<el-input size="small"  @keyup.enter.native="search" v-model="formInline.priceName" placeholder="尖峰平谷规则名称"></el-input>
			</el-form-item> -->
		  <el-form-item v-if="user.username == 'admin'">

			 <el-select v-model="formInline.depId" placeholder="请选择" @change="getdata" size="small">
				<el-option
				  v-for="item in deptData"
				  :key="item.id"
				  :label="item.departmentName"
				  :value="item.id">
				</el-option>
			  </el-select>
		  </el-form-item>

			<el-form-item>
				<!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
				<el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
				<!-- <prems-button size="small" type="primary" icon="el-icon-circle-plus-outline"  perms="rule:add" @click="handleEdit()" label="添加" /> -->

			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
			<el-table-column align="center" type="index" width="60" label="序号">
			</el-table-column>
			<el-table-column prop="jfpgPriceName" label="电价名称">
			</el-table-column>

			<el-table-column label="尖电价" prop="jPrice">
			</el-table-column>
      <el-table-column label="峰电价" prop="fPrice">
      </el-table-column>

      <el-table-column label="平电价" prop="pPrice">
      </el-table-column>
      <el-table-column label="谷电价" prop="gPrice">
      </el-table-column>
			<!-- <el-table-column prop="fixedTelephoneNumber" label="组合描述">
			</el-table-column>
 -->
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<!-- <prems-button size="mini"   perms="rule:detail" @click="handleEdit(scope.$index, scope.row)" label="编辑" /> -->
					<el-button size="mini" @click="handleSet(scope.$index, scope.row)">设置</el-button>
					<!-- <prems-button size="mini"  type="warning"   perms="rule:detail" @click="handleSet(scope.$index, scope.row)" label="设置" /> -->
					<el-button size="mini" type="danger"  @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
					<!-- <prems-button size="mini"  type="danger"   perms="rule:delete" @click="deleteInfo(scope.$index, scope.row)" label="删除" /> -->
				</template>
			</el-table-column>
		</el-table>

    <el-dialog :visible.sync="editFormVisible" width="50%" @click='editFormVisible = false' :title="title" :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="部门">
          <el-select v-model="editForm.depId"   placeholder="请选择"  size="small">
             <el-option
               v-for="item in deptData"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
        </el-form-item>



        <el-form-item label="名称" prop="jfpgPriceName">
          <el-input size="small" v-model="editForm.jfpgPriceName" auto-complete="off" placeholder="请输入尖峰平谷电价名称"></el-input>
        </el-form-item>
        <el-form-item label="尖时段" prop="jPrice">
          <el-input size="small" v-model="editForm.jPrice" auto-complete="off" placeholder="请输入尖时段电价"></el-input>
        </el-form-item>
        <el-form-item label="峰时段" prop="fPrice">
          <el-input size="small" v-model="editForm.fPrice" auto-complete="off" placeholder="请输入峰时段电价"></el-input>
        </el-form-item>
        <el-form-item label="平时段" prop="pPrice">
          <el-input size="small" v-model="editForm.pPrice" auto-complete="off" placeholder="请输入平时段电价"></el-input>
        </el-form-item>
        <el-form-item label="谷时段" prop="gPrice">
          <el-input size="small" v-model="editForm.gPrice" auto-complete="off" placeholder="请输入谷时段电价"></el-input>
        </el-form-item>
      </el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='editFormVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="addPrice()">确认</el-button>
    	</div>
    </el-dialog>



		<el-dialog title="绑定计量点" :visible.sync="setFormVisible" width="45%" @click='closeDialog("set")'>
      <el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>



      	<el-form-item>
      		<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="getMeterForNoBind">添加</el-button>
      	</el-form-item>
        <el-form-item>
          <el-button type="danger" size="small" style="margin-bottom: 10px;" @click="delMeter"  :disabled="!tempDelMeterList.length" >删除</el-button>
        </el-form-item>
      </el-form>


			<div style="line-height: 30px;">当前绑定的计量点</div>
			<el-table size="small" :data="selectList" height="500px"  v-loading="loadjl"  border  @selection-change="getDelMeterIds">
				<el-table-column type="selection"></el-table-column>
				<el-table-column label="id" prop="id" width="100"></el-table-column>
				<el-table-column label="计量点名称" prop="meterName"></el-table-column>
				<el-table-column label="计量点通迅地址" prop="meterPoint"></el-table-column>

			</el-table>
			<div style="line-height: 40px;">共计:{{selectList.length}}</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog()'>取消</el-button>
				<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
			</div>
		</el-dialog>
		<!-- 添加计量点界面 -->
		<el-dialog :visible.sync="addFormVisible" width="50%" @click='addFormVisible = false' title="选择计量点">
      <el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>

        <el-form-item v-if="user.username == 'admin'" label="选择集中器:">

           <el-select v-model="terminalId" placeholder="请选择" @change="getMeterInfoList" size="small">
              <el-option
                v-for="item in terList"
                :key="item.id"
                :label="item.terminalName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>

      <!-- 	<el-form-item>
      		<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="getMeterForNoBind">添加</el-button>
      	</el-form-item>
        <el-form-item>
          <el-button type="danger" size="small" style="margin-bottom: 10px;" @click="delMeter"  :disabled="!tempDelMeterList.length" >删除</el-button>
        </el-form-item> -->
      </el-form>
			<el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input>
			<el-table size="small" :data="tables" height="500px"  @selection-change="getAddMeterIds" ref='bindTable'
			 v-loading="loadMeter">
				<el-table-column type="selection"></el-table-column>
				<el-table-column label="id" prop="id" width="100"></el-table-column>
				<el-table-column label="计量点名称" prop="meterName"></el-table-column>
				<el-table-column label="计量点通迅地址" prop="meterPoint" width="200"></el-table-column>
        <el-table-column label="绑定电价名称" prop="jfpgPriceName" width="200"></el-table-column>

			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='addFormVisible = false'>取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading" class="title" @click="bindPrice()">确认</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
  import { getDepartmentTerminalInfoLis} from '../../api/energyMG'
	import PremsButton from "@/views/permission/PreButtom";
	import {
		mapState
	} from 'vuex'
	import {
		addPriceConfig,
		getPriceConfigList,
		deletePriceConfig,
		updatePriceConfig,
		findAllMeterInfoList,
		priceBindMeterinfo,
		checkPriceBindMeterinfo,
		sendMeterInfoMsg,


    saveOrModifyJfpgPrice,
    findJfpgPrices,
    removeJfpgPrice,
    saveMeterInfoPrice,
    findMeterInfosByPirceId,
    findMeterInfosByTerminalId

	} from '../../api/payMG.js'
	export default {
		data() {
			var checkPrice = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('电价不能为空'));
				}
				setTimeout(() => {
					if (value <= 0) {
						callback(new Error('电价不能小于或者等于0'));
					} else {
						callback();
					}
				}, 1000);
			};
			return {

        user:{},
				selectDatas: [],
				selectList: [],
				formInline: {
					depId:""
				},
        loadjl:false,
        terminalId:"",
        meterName:"",
        loadingSave:false,
				editForm: {
					jfpgPriceName:"",
          jPrice:"",
          fPrice:"",
          pPrice:"",
          gPrice:"",
          depId:""
				},
        priceId:"",
				curPriceConfigId:"",
        terList:[],
				title: '添加',
				dataList: [],

				loading: false,
				setLoading: false,
				loadMeter: false,
				editFormVisible: false,
				setFormVisible: false,
				addFormVisible: false,
				searchDatas: "",
				direction: "rtl",
				meterPointName: "",
				MeterInfoList: [],
				tempDelMeterList:[],
				tempAddMeterList:[],
				curPriceId: "",
				choiseNum: 0,
				energyType:"",
				getJZ:"",
        deptData:[],
				rules: {

					jfpgPriceName: [{
						required: true,
						message: '请输入电价名称',
						trigger: 'blur'
					}],
					jPrice: [{
            required: true,
						message: '请输入请输入尖时段电价',
						trigger: 'blur'
					}],

          fPrice: [{
            required: true,
          	message: '请输入请输入峰时段电价',
          	trigger: 'blur'
          }],

          pPrice: [{
            required: true,
          	message: '请输入请输入平时段电价',
          	trigger: 'blur'
          }],

          gPrice: [{
            required: true,
          	message: '请输入请输入谷时段电价',
          	trigger: 'blur'
          }]

				},
			}
		},


		created() {

			this.$store.dispatch('getEnergyTypeConfig').then( () => {
				this.energyType = this.energyConfig.filter(item => item.value == '电力')[0].id

			})
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.formInline.depId = this.user.departmentId

      this.getJzData()
		},

		computed: {
			tables() {
				let search = this.searchDatas
				if (search) {
					return this.MeterInfoList.filter(data => {
						return Object.keys(data).some(key => {
							return String(data[key]).toLowerCase().indexOf(search) > -1
						})
					})
				}
				return this.MeterInfoList
			},
			...mapState({
				energyConfig: 'energyConfig'
			})
		},
		methods: {

			getDelMeterIds(e){
				this.tempDelMeterList = e.map(item => item.id)
			},
			delMeter(e){

        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
            let arr = []
            this.selectList.forEach(item =>{
            	console.log(item.id)
            	if (!(this.tempDelMeterList.indexOf(item.id) > -1)) {
            		arr.push(item)
            	}

            })
            let currMeterIds = arr.map(item => item.id).join('-')

            let param = {
            	priceId: this.curPriceId,
            	meterIds: currMeterIds
            }

        		// 删除
        		saveMeterInfoPrice(param)
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getMtersByPriceId()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})

        	})


			},
			getAddMeterIds(e){
				this.tempAddMeterList = e

			},
			addMeters(){
				this.addFormVisible = false
				this.tempAddMeterList = []
			},
			searchMeter(e) {

			},
			subBindMeter() {

				//检查计量点是否已经绑定了其他价格
				// checkPriceBindMeterinfo(param).then(res => {
				// 	if (res.status == 1) {
				// 		this.bindMeter(param)
				// 	} else {
    //          let nmsg = res.msg.replace(/,/g,"<br/>")
				// 		this.$confirm(nmsg, '信息', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'warning'
				// 		}).then(() => {
				// 			this.bindMeter(param)
				// 		})
				// 	}
				// })
			},
			bindPrice() {
				this.setLoading = true
        let arr = this.selectList.concat(this.tempAddMeterList)
        // this.selectList = Array.from(new Set(arr))
        let currMeterIds = Array.from(new Set(arr)).map(item => item.id).join('-')


        let param = {
        	priceId: this.curPriceId,
        	meterIds: currMeterIds
        }

				saveMeterInfoPrice(param)

					.then(res => {
            this.setLoading = false
						this.addFormVisible = false
						if (res.status == 1) {
							this.$message({
								type: 'success',
								message: '操作成功！'
							})

              this.getMtersByPriceId()
              this.$refs.bindTable.clearSelection();
							// this.$store.dispatch('getSendMsg')
							//this.meterPointName = ""

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.setFormVisible = false
						this.setLoading = false
						this.$message.error('操作失败，请稍后再试！')
					})
			},
			getMeterForNoBind(){
				this.addFormVisible = true
				this.getMeterInfoList()
			},

			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
				this.getdata()
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'

          this.editForm.jfpgPriceName = row.jfpgPriceName
          this.editForm.jPrice = row.jPrice
          this.editForm.fPrice = row.fPrice
          this.editForm.pPrice = row.pPrice
          this.editForm.gPrice = row.gPrice
          this.editForm.depId = row.deparmentId
          this.editForm.id = row.id


				} else {
					this.title = '添加'
          this.editForm.id = ""
          this.editForm.jfpgPriceName =  ""
          this.editForm.jPrice =  ""
          this.editForm.fPrice =  ""
          this.editForm.pPrice =  ""
          this.editForm.gPrice =  ""
          this.editForm.depId = ""

				}
			},

			//设置弹窗
			handleSet(index, row) {
				this.setFormVisible = true
				this.curPriceId = row.id
				this.selectDatas = []


        this.terList = this.deptData.filter(item => item.id == this.formInline.depId)[0].terminalInfo
        this.terminalId = this.terList[0].id
        this.priceId = row.id
        this.getMtersByPriceId()

				// this.selectDatas = row.meterInfoVoList.map(item => item.id)
				// this.selectList = row.meterInfoVoList
        //this.getMtersByPriceId(row.id)

			},

      getMtersByPriceId(id){
        this.loadjl = true
        findMeterInfosByPirceId({priceId:this.priceId}).then(res => {
          this.loadjl = false
          if(res.status == 1){
            this.selectList = res.data.data
          }
        })
      },


      //获取部门信息
      getJzData:function(){
        this.loading = true
        getDepartmentTerminalInfoLis().then(res => {

        if(res.status == 1){

          this.deptData = res.data.menuDepList
          this.formInline.depId = res.data.menuDepList[0].id
          this.getdata();

        }
        else{
          this.$message.error(res.msg)
        }
      })

      },
      handleNodeClick(){

      },

			getMeterInfoList() {
				this.loadMeter = true
				let param = {
					terminalId: this.terminalId,
					meterName:this.meterName
				}
				findMeterInfosByTerminalId(param).then(res => {
					this.loadMeter = false
					if (res.status == 1) {

						this.MeterInfoList = res.data.data

						//this.setChoisMeter(row)
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.loadMeter = false
					this.$message.error('获取数据失败，请稍后再试！')
				})

			},
			setChoisMeter(row) {
				let tempArr = []
				this.$nextTick(() => {
					this.$refs.bindTable.clearSelection(); //清除上一次除勾选项

					row.meterInfoVoList.forEach(item => {
						this.MeterInfoList.forEach((sitem, idx) => {
							if (item.id == sitem.id) {
								this.$refs.bindTable.toggleRowSelection(this.MeterInfoList[idx], true)
							}
						})
					})

				})
			},

			// 编辑、添加提交方法
			submitForm(editData) {
        this.loadingSave = true
				this.$refs[editData].validate(valid => {
					if (valid) {

						if (this.title == '添加') {
							this.add();
						} else {
							this.update();
						}

					} else {
            this.loadingSave = false
						return false
					}
				})
			},



			getdata() {
				this.loading = true
				findJfpgPrices(this.formInline).then(res => {
						this.loading = false
						if (res.status == 1) {
							this.dataList = res.data.data
							分页赋值
							this.pageparm.currentPage = this.formInline.currentPage
							this.pageparm.pageSize = this.formInline.pageSize
							this.pageparm.total = res.data.totalCount
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})

			},
			addPrice() {


        this.$refs['editForm'].validate(valid => {

        	if(valid){
           saveOrModifyJfpgPrice(this.editForm)
           	.then(res => {
           		this.setLoading = false
           		this.editFormVisible = false
           		this.loading = false
           		if (res.status == 1) {
           			 this.getdata(this.formInline)
           			this.$message({
           				type: 'success',
           				message: '操作成功！'
           			})
           		} else {
                 this.setLoading = false
           			this.$message({
           				type: 'info',
           				message: res.msg
           			})
           		}
           	})
          }
        })




			},
			update() {
				let param = {
					...this.editForm,
					powerType: this.energyType
				}
        this.loadingSave = true
				updatePriceConfig(param)
					.then(res => {
            this.loadingSave = false
						this.editFormVisible = false
						this.loading = false
						if (res.status == 1) {
							this.getdata(this.formInline)
							this.$message({
								type: 'success',
								message: '操作成功！'
							})
						} else {
              this.loadingSave = false
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false

            this.loadingSave = false
						this.$message.error('操作失败，请稍后再试！')
					})
			},
			// 删除
			deleteInfo(index, row) {
				this.$confirm('确定要删除吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						// 删除
						removeJfpgPrice({
								id: row.id
							})
							.then(res => {
								if (res.status == 1) {
									this.$message({
										type: 'success',
										message: '已删除!'
									})
									this.getdata(this.formInline)
								} else {
									this.$message({
										type: 'info',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.loading = false
								this.$message.error('删除失败，请稍后再试！')
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除！'
						})
					})
			},


			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
				this.setFormVisible = false
			}
		},
		components: {

			PremsButton
		},
	}
</script>

<style scoped>
	.el-avatar,
	.el-drawer {
		overflow-y: auto !important;
	}

	.electriRule.dialog-footer {
		position: absolute;
		padding: 30px;
		text-align: right;
		bottom: 30px;
		right: 0;
	}
</style>



// WEBPACK FOOTER //
// src/views/prepayment/jrule.vue